/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { locale2 as locale } from "dc-core";

export const getLocaleAndLoadTranslations = async () => {
  let translation;
  try {
    const loc = locale.getLocale();
    if (loc) {
      translation = await loadTranslation(loc);
    } else {
      translation = await loadTranslation("en-US");
    }
  } catch (err) {
    translation = await loadTranslation("en-US");
  }
  return translation;
};
export const getMessage = async (key, placeholders = {}) => {
  let translation = await getLocaleAndLoadTranslations();
  if (!translation[key]) {
    translation = await loadTranslation("en-US");
  }
  return Object.keys(placeholders).reduce((message, placeholder) => {
    if (message.includes(`{${placeholder}}`)) {
      const searchRegExp = new RegExp(`{${placeholder}}`, "g");
      message = message.replace(searchRegExp, placeholders[placeholder]);
    }
    return message;
  }, translation[key]);
};

const loadTranslation = locale =>
  new Promise(async resolve => {
    try {
      const json = await import(/* webpackChunkName: "translations-[request]" */ `translations/${locale}.json`); // eslint-disable-line global-require
      resolve(json);
    } catch (e) {
      resolve({});
    }
  });

export default loadTranslation;
